import StringMask from 'string-mask';
import autoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const phoneMasks = {
  '7D': {
    areaCode: new StringMask('(00) 000-0000'), // with area code
    simple: new StringMask('000-0000') // without area code
  },
  '8D': {
    areaCode: new StringMask('(00) 0000-0000'), // with area code
    simple: new StringMask('0000-0000') // without area code
  },
  '9D': {
    areaCode: new StringMask('(00) 00000-0000'), // with area code
    simple: new StringMask('00000-0000') // without area code
  },
  '0800': {
    areaCode: null, // N/A
    simple: new StringMask('0000-000-0000') // N/A, so it's "simple"
  }
};

export const digits = str => (str || '').replace(/[^0-9]/g, '');

export const readPhone = (str = '') => {
  let formattedValue;
  if (str.length === 9) {
    formattedValue = phoneMasks['7D'].areaCode.apply(str);
  } else if (str.length < 11) {
    formattedValue = phoneMasks['8D'].areaCode.apply(str);
  } else {
    formattedValue = phoneMasks['9D'].areaCode.apply(str);
  }
  return formattedValue;
};

export const readMoney = str => `R$ ${str.toFixed(2).replace('.', ',')}`;

export const masks = {
  cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  cep: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  phoneNumber: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  datePipe: autoCorrectedDatePipe('dd/mm/yyyy'),

  money: createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ','
  })
};



// WEBPACK FOOTER //
// ./src/helpers/format.js